import { Injectable } from '@angular/core';
import { PreferenceDataService } from '../data-services/preference.service';
import { GetAllActiveDealerResponseModel, Preferences } from '../business-entities/preferences-model';
import { GenericResponse } from '../business-entities/generic-response';

@Injectable({
  providedIn: 'root'
})
export class PreferenceBusinessService {
  constructor(private service: PreferenceDataService) {
  }
  PreferenceId: number
  preferenceList: Preferences[];
  preference: Preferences;
  getAllActiveDealerList: GetAllActiveDealerResponseModel[];
  async getPreferenceList(vehicalObj: any): Promise<Preferences[]> {
    await this.service
      .getPreferenceList(vehicalObj)
      .then(
        (res: GenericResponse<Array<Preferences>>) => {
          this.preferenceList = res.responseObject;
        }
      );
    return this.preferenceList;
  }
  deletePreference(id: number): Promise<any> {
    return this.service.deletePreference(id);
  }

  activeInactivePreference(vehicalObj: any): Promise<any> {
    return this.service.activeInactivePreference(vehicalObj);
  }

  async getPreferenceById(preferenceId: number) {
    return this.service.getPreferenceById(preferenceId);
  }

  async addEditPreference(model: any): Promise<any> {
    return this.service.addEditPreference(model);
  }
  activeInactiveDealer(dealerId): Promise<any> {
    let model = {
      DealerId: dealerId,
    }
    return this.service.activeInactiveDealer(model);
  }
  async getAllActiveDealer(): Promise<GetAllActiveDealerResponseModel[]> {
    await this.service
      .getAllActiveDealer()
      .then(
        (res:  GenericResponse<Array<GetAllActiveDealerResponseModel>>) => {
          this.getAllActiveDealerList = res.responseObject;
        }
      );
    return this.getAllActiveDealerList;
  }
}
